'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function MPFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-9k6efq31z", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-9k6efq31z)" }, /* @__PURE__ */ React.createElement("path", { fill: "#2993ec", d: "M0 0h34v24H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f1f9ff",
        fillRule: "nonzero",
        d: "M16 21.167c-5.405 0-9.787-4.29-9.787-9.584C6.213 6.291 10.595 2 16 2s9.787 4.29 9.787 9.583-4.382 9.584-9.787 9.584zm0-2.084c4.23 0 7.66-3.358 7.66-7.5 0-4.142-3.43-7.5-7.66-7.5s-7.66 3.358-7.66 7.5c0 4.142 3.43 7.5 7.66 7.5z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e31d1c",
        fillRule: "nonzero",
        d: "M16 20.333c-4.935 0-8.936-3.917-8.936-8.75 0-4.832 4-8.75 8.936-8.75 4.935 0 8.936 3.918 8.936 8.75 0 4.833-4 8.75-8.936 8.75zm0-.416c4.7 0 8.51-3.731 8.51-8.334 0-4.602-3.81-8.333-8.51-8.333-4.7 0-8.51 3.731-8.51 8.333 0 4.603 3.81 8.334 8.51 8.334z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fdda33",
        d: "M6.084 9.77c.2.145.503.253.907.324.404.071.78.299 1.13.683a9.603 9.603 0 01-1.228-.127c-.363-.064-.633-.357-.809-.88zm19.231.715c-.238-.067-.559-.065-.963.006-.403.071-.835-.014-1.295-.255a9.603 9.603 0 011.197-.302c.363-.064.717.12 1.061.551zM6.811 7.667c.162.187.433.36.81.52.378.16.694.467.948.92a9.603 9.603 0 01-1.169-.4c-.339-.144-.536-.49-.59-1.04zm17.936.67c-.248-.013-.56.06-.937.221s-.818.175-1.32.043c.393-.231.76-.419 1.099-.563.34-.144.725-.045 1.158.298zM8.027 5.773c.113.22.333.453.66.7.328.247.56.62.698 1.122a9.603 9.603 0 01-1.037-.67c-.295-.223-.401-.606-.32-1.152zm15.656.58c-.242.048-.527.195-.855.442-.328.247-.751.367-1.27.36.325-.319.635-.59.93-.811.294-.222.693-.219 1.195.009zM9.64 4.217c.06.24.222.517.486.831s.406.73.427 1.25c-.336-.309-.623-.604-.86-.887s-.255-.68-.053-1.194zm12.552.467c-.226.101-.47.309-.734.623s-.65.527-1.157.637c.246-.384.487-.718.724-1 .237-.282.626-.37 1.167-.26zM11.573 3.066c.005.247.1.553.286.919.187.365.232.803.135 1.314a9.603 9.603 0 01-.638-1.058c-.167-.328-.095-.72.217-1.175zm8.775.33c-.197.149-.389.406-.575.772-.186.365-.514.66-.984.881.153-.43.313-.81.48-1.138s.527-.5 1.08-.515zm-6.603-1.013c-.055.242-.036.562.056.962s.03.835-.187 1.307a9.603 9.603 0 01-.364-1.18c-.082-.36.082-.722.495-1.089zm4.491.164c-.155.193-.279.489-.371.888s-.34.764-.741 1.094c.044-.455.108-.861.19-1.22.083-.36.39-.614.922-.762zM16 2.208c-.108.223-.162.54-.162.95s-.159.82-.476 1.231c-.06-.452-.089-.863-.089-1.231s.242-.685.727-.95z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#a7a7a7",
        d: "M17.627 5.75a.574.574 0 01.56.697l-.386 1.768a.574.574 0 01-.257.365c.118.09.2.227.218.385L19.15 20.6a.575.575 0 01-.273.56c-.923.56-1.846.839-2.77.839-.923 0-1.846-.28-2.77-.84a.574.574 0 01-.272-.559L14.45 8.965a.573.573 0 01.22-.387.569.569 0 01-.258-.363l-.387-1.768a.574.574 0 01.561-.697z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#73be4a",
        fillRule: "nonzero",
        d: "M6.52 12.013c.05-.165.23-.258.398-.208s.263.226.212.39c-.09.286-.09.708.009 1.26.038.211.082.375.138.52.022.057.044.11.075.175l.079.169c.095.216.137.405.137.682 0 .173-.143.313-.32.313s-.318-.14-.318-.313a.94.94 0 00-.085-.434l-.074-.158a3.207 3.207 0 01-.092-.216 3.415 3.415 0 01-.169-.63c-.114-.64-.114-1.155.01-1.55z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M16.213 16.18l-4.115 2.803 1.452-4.698-3.995-2.966 5.012-.1 1.646-4.636 1.646 4.636 5.011.1-3.994 2.966 1.451 4.698z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#73be4a",
        fillRule: "nonzero",
        d: "M25.56 12.43a.32.32 0 00-.4-.208.311.311 0 00-.21.39c.088.286.088.708-.01 1.26a2.807 2.807 0 01-.138.519c-.022.057-.045.11-.075.175l-.079.17a1.546 1.546 0 00-.137.682c0 .173.143.312.319.312s.319-.14.319-.312a.94.94 0 01.085-.434l.074-.159c.036-.077.064-.142.092-.215a3.4 3.4 0 00.169-.631c.114-.64.114-1.155-.01-1.55z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        stroke: "#73be4a",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.06 3.148c.777.345.998.79.662 1.335m.19-1.335c.776.345.997.79.661 1.335"
      }
    ), /* @__PURE__ */ React.createElement("g", { fill: "#73be4a", fillRule: "nonzero" }, /* @__PURE__ */ React.createElement("path", { d: "M9.26 6.357a.274.274 0 01.396-.099.329.329 0 01.09.431c-.162.28-.246.665-.246 1.159 0 .172-.129.312-.287.312s-.288-.14-.288-.312c0-.603.11-1.102.335-1.491z" }), /* @__PURE__ */ React.createElement("path", { d: "M8.809 9.213c0 .172-.13.312-.288.312-.158 0-.287-.14-.287-.312v-.89c0-.63.099-1.127.307-1.489.084-.146.262-.19.396-.099s.175.284.091.43c-.143.25-.22.635-.22 1.157zm14.675-.417c0 .172.129.312.287.312s.288-.14.288-.312v-.89c0-.63-.1-1.126-.307-1.488a.274.274 0 00-.396-.1.329.329 0 00-.091.431c.142.248.22.634.22 1.157z" }), /* @__PURE__ */ React.createElement("path", { d: "M24.335 10.254c0 .173.129.313.287.313.16 0 .288-.14.288-.313v-.89c0-.63-.1-1.126-.307-1.488a.274.274 0 00-.396-.1.329.329 0 00-.091.431c.142.249.22.634.22 1.157z" }))))
  );
}

export { MPFlag };
//# sourceMappingURL=MP.mjs.map
